export default __webpack_public_path__ + "static/media/verifiedIcon.22e28b44.svg";